// extracted by mini-css-extract-plugin
module.exports = {"root":"DescriptionDropdown_root__1addS","description":"DescriptionDropdown_description__1nk5h"};